import { createLegacyIssueInteraction } from './createLegacyIssueInteraction.tsx';

export const legacyIssueCreateInitialRenderInteraction: ReturnType<
	typeof createLegacyIssueInteraction
> = createLegacyIssueInteraction('legacy-issue-create.initial-render');
